import localforage from 'localforage';

const REMEMBERED_ID_KEY = 'signin.remembered_id';

const LEGACY_SIGNIN_KEYS = [
  'signin.session',
  'signin.step',
  'signin.id_payload',
  'profile.user',
] as const;

export const readRememberedId = (): string => {
  try {
    return localStorage.getItem(REMEMBERED_ID_KEY)?.trim() ?? '';
  } catch {
    return '';
  }
};

export const saveRememberedId = (value: string) => {
  const id = value.trim();
  if (!id) return;
  try {
    localStorage.setItem(REMEMBERED_ID_KEY, id);
  } catch {}
};

export const clearRememberedId = () => {
  try {
    localStorage.removeItem(REMEMBERED_ID_KEY);
  } catch {}
};

export const purgeLegacySigninStorage = () => {
  LEGACY_SIGNIN_KEYS.forEach((key) => {
    try {
      localforage.removeItem(key).catch(() => {});
    } catch {}
  });
};
